// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface IndentRightIconSignature {
  Element: SVGSVGElement;
}

export const IndentRightIcon: TOC<IndentRightIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11 2H13V22H11V2ZM22 11H17.414L18.707 9.708L17.293 8.294L13.586 12L17.293 15.708L18.707 14.294L17.414 13H22V11ZM10 3H2V5H10V3ZM4 7H10V9H4V7ZM10 11H2V13H10V11ZM4 15H10V17H4V15ZM10 19H2V21H10V19Z"/>
</svg>
</template>;